export default __webpack_public_path__ + "4280534dd8e84a505d6abcfaf2a985cc.png";